export default [
  {
    name: 'project_contributions_statistic',
    component_path: 'modules/templates/blocks/project/ProjectStatistic',
    settings: {
      statistic: 'contributions_count',
      text: 'contributions'
    }
  }
]